module.exports = __webpack_public_path__ + "img/logo-darkfans-black-white.cbd76669.svg";